import { render } from "./ProfilePanelUserFriend.vue?vue&type=template&id=bae0b390&scoped=true"
import script from "./ProfilePanelUserFriend.vue?vue&type=script&lang=js"
export * from "./ProfilePanelUserFriend.vue?vue&type=script&lang=js"

import "./ProfilePanelUserFriend.vue?vue&type=style&index=0&id=bae0b390&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae0b390"]])

export default __exports__